import {
  SalesRequirementModel,
  ISalesRequirementModel,
} from '@common/models/SalesRequirementModel';
import { http } from '@common/utils';
import { trackPromise } from 'react-promise-tracker';
import { ServiceHelper } from '../serviceHelper';
import { ServiceMethodOptions } from '../types';

export class SalesRequirementService {
  private static baseUrl: string = '/api/salesrequirement';
  static tags = {
    upsertSalesRequirement: 'upsertSalesRequirement',
    getSalesRequirements: 'getSalesRequirements',
    deleteSalesRequirement: 'deleteSalesRequirement',
  };

  static getSalesRequirements = (
    options?: ServiceMethodOptions,
  ): Promise<SalesRequirementModel[]> => {
    return trackPromise(
      new Promise<SalesRequirementModel[]>((resolve, reject) => {
        http(`${this.baseUrl}`)
          .get<ISalesRequirementModel[]>()
          .then((response) => {
            ServiceHelper.showSuccess('Sales Requirement fetched.', options);
            resolve(response);
          })
          .catch((err) => {
            ServiceHelper.showError(
              'Failed to get Sales Requirement.',
              options,
            );
            reject(err);
          });
      }),
      this.tags.getSalesRequirements,
    );
  };

  static upsertSalesRequirement = (
    data: ISalesRequirementModel,
    options?: ServiceMethodOptions,
  ): Promise<SalesRequirementModel> => {
    return trackPromise(
      new Promise<ISalesRequirementModel>((resolve, reject) => {
        http(`${this.baseUrl}`)
          .post<ISalesRequirementModel>(data)
          .then((response) => {
            ServiceHelper.showSuccess('Sales Requirement updated.', options);
            resolve(new SalesRequirementModel(response));
          })
          .catch((err) => {
            ServiceHelper.showError(
              'Failed to update Sales Requirement.',
              options,
            );
            reject(err);
          });
      }),
      this.tags.upsertSalesRequirement,
    );
  };
  static deleteSalesRequirement = (
    salesRequirementId: number,
    options?: ServiceMethodOptions,
  ): Promise<boolean> => {
    return trackPromise(
      new Promise<boolean>((resolve, reject) => {
        http(`${this.baseUrl}/${salesRequirementId}`)
          .delete()
          .then(() => {
            ServiceHelper.showSuccess(
              'Sales Requirement has been deleted.',
              options,
            );
            resolve(true);
          })
          .catch((err) => {
            ServiceHelper.showError(
              'Failed to delete Sales Requirement.',
              options,
            );
            reject(err);
          });
      }),
      this.tags.deleteSalesRequirement,
    );
  };
}
